<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <div v-for="(item,i) in result" :key="i">
            <div class="text-2xl font-bold my-5">{{ item[groupByFilters(form.getFieldValue('group_by'))] }}</div>
            <div v-for="(matter,index) in item.matters" :key="index">
              <div class="font-semibold my-5">{{ matter.name }}</div>
              <div class="flex gap-1 pb-2">
                <feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                <div class="font-medium">Expense Entries</div>
              </div>
              <a-table :dataSource="matter.expense_entries" :columns="columnsExpense" :pagination="false"  class="tbl-receivable">
                <template slot="description" slot-scope="text,record">
                  {{ limitTextTask(record.description) }}
                </template>
                <template slot="usedInvoice" slot-scope="text,record">
                  <template v-if="record.is_used_in_invoice">Billed</template>
                  <template v-else>Unbilled</template>
                </template>
                <template slot="reference" slot-scope="text,record">
                  {{ limitTextTask(record.reference) }}
                </template>
                <template slot="user" slot-scope="text,record">
                  {{ record.user_name }}
                </template>
                <template slot="vendor" slot-scope="text,record">
                  {{ record.vendor }}
                </template>
                <template slot="date" slot-scope="text,record">
                  {{ setDateFormat(record.date) }}
                </template>
                <template slot="footer">
                  <!--                <template v-if="matter.expense_entries.length">-->
                  <!--                  <div class="flex flex-col justify-evenly gap-y-2">-->
                  <!--                    <div class="flex justify-between gap-4">-->
                  <!--                      <div class="font-bold">Billed Total:</div>-->
                  <!--                      <div>{{ 'RM' + sumColAmount(matter.expense_entries,'amount').filterBilled }}</div>-->
                  <!--                    </div>-->
                  <!--                    <div class="flex justify-between gap-4">-->
                  <!--                      <div class="font-bold">UnBilled Total:</div>-->
                  <!--                      <div>{{ 'RM' + sumColAmount(matter.expense_entries,'amount').filterUnBilled }}</div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </template>-->
                </template>
              </a-table>
              <div class="flex gap-1 py-5">
                <feather-icon icon="ClockIcon" svg-classes="text-primary w-4 h-4"></feather-icon>
                <div class="font-medium">Time Entries</div>
              </div>
              <a-table :dataSource="matter.time_entries" :columns="columnsTimes" :pagination="false"  class="tbl-receivable">
                <template slot="description" slot-scope="text,record">
                  {{ limitTextTask(record.description) }}
                </template>
                <template slot="date" slot-scope="text,record">
                  {{ setDateFormat(record.date) }}
                </template>
                <template slot="usedInvoice" slot-scope="text,record">
                  <template v-if="record.is_used_in_invoice">Billed</template>
                  <template v-else>Unbilled</template>
                </template>
                <template slot="reference" slot-scope="text,record">
                  {{ limitTextTask(record.reference) }}
                </template>
                <template slot="user" slot-scope="text,record">
                  {{ record.user_name }}
                </template>
                <template slot="vendor" slot-scope="text,record">
                  {{ record.vendor }}
                </template>
                <template slot="total" slot-scope="text,record">
                  {{ record.rate * record.duration  }}
                </template>
                <template slot="footer">
                  <!--                <template v-if="matter.time_entries.length">-->
                  <!--                  <div class="flex flex-col justify-evenly gap-y-2">-->
                  <!--                    <div class="flex justify-between gap-4">-->
                  <!--                      <div class="font-bold">Billed Total:</div>-->
                  <!--                      <div>{{ 'RM' + sumColAmount(matter.time_entries,'amount_time').filterBilled }}</div>-->
                  <!--                    </div>-->
                  <!--                    <div class="flex justify-between gap-4">-->
                  <!--                      <div class="font-bold">UnBilled Total:</div>-->
                  <!--                      <div>{{ 'RM' + sumColAmount(matter.time_entries,'amount_time').filterUnBilled }}</div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </template>-->
                </template>
              </a-table>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group v-decorator="['which_responsible',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeResponsible">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="Responsible"
              field="responsible"
              :required="false"
              method="get"
              mode="multiple"
              placeholder="Find A User"
              class="w-full xl:w-1/2 self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Originating Lawyer">
              <a-radio-group v-decorator="['which_originating',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleChangeOriginating">
                <a-radio :style="radioStyle" :value="1">
                  All Originating Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Originating Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="originating_value === 2"
              url="/account/list/"
              label="Originating"
              field="origination"
              :required="false"
              method="get"
              placeholder="Find A User"
              mode="multiple"
              class="w-full xl:w-1/2 self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client">
              <a-radio-group v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]" @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="false"
              @selectSearch="handleSearch"
            />
          </div>
          <a-form-item label="Group Results By">
            <a-select v-decorator="['group_by',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]">
              <a-select-option :value="1">
                Client
              </a-select-option>
              <a-select-option :value="2">
                Responsible Lawyer
              </a-select-option>
              <a-select-option :value="3">
                User
              </a-select-option>
            </a-select>
          </a-form-item>
          <!--        <a-form-item>-->
          <!--          <a-checkbox>Add page break after group (PDF format only)</a-checkbox>-->
          <!--        </a-form-item>-->
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area" field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-4"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','ClientReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columnsExpense = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: '1',
    scopedSlots: { customRender: 'date' },
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: '2',
    scopedSlots: { customRender: 'user' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Used invoice',
    dataIndex: 'used_invoice',
    key: '4',
    scopedSlots: { customRender: 'usedInvoice' },
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: '5',
    scopedSlots: { customRender: 'reference' },
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    key: '6',
    scopedSlots: { customRender: 'vendor' },
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: '7',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    key: '8',
  },
  {
    title: 'Total',
    dataIndex: 'amount',
    key: '9',
  },
]
const columnsTimes = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: '1',
    scopedSlots: { customRender: 'date' }
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: '2',
    scopedSlots: { customRender: 'user' },
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: '3',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Used invoice',
    dataIndex: 'used_invoice',
    key: '4',
    scopedSlots: { customRender: 'usedInvoice' },
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: '5',
    scopedSlots: { customRender: 'reference' },
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: '6',
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    key: '7',
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: '8',
    scopedSlots: { customRender: 'total' },
  },
]

export default {
  name: "ComponentGeneral",
  mixins:[mixin],
  components:{
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data(){
    return{
      responsible_value    : null,
      originating_value    : null,
      checked_matter_client: null,
      title:'Work in Progress',
      columnsExpense,
      columnsTimes,
      result : [],
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods:{
    handleChangeResponsible({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ responsible: [] })
      this.responsible_value = value
    },
    handleChangeOriginating({target:{value}}){
      if (value === 1)
        this.form.setFieldsValue({ origination: [] })
      this.originating_value = value
    },
    handleReport(){
      this.form.validateFields(async (err,values)=>{
        if(!err){
          try {
            this.$refs.reportSubmit.loading = true
            const query     = []
            if (values.contact)       query.push({ field:'id', condition: '=', value: values.contact, operation: 'and' })
            if (values.responsible && values.responsible.length) query.push({ field:'responsible', condition: 'in', value: values.responsible, operation: 'and' })
            if (values.origination && values.origination.length) query.push({ field:'origination', condition: 'in', value: values.origination, operation: 'and' })
            if (values.practice_area) query.push({ field:'practice_area', condition: '=', value: values.practice_area, operation: 'and' })
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('contact/report/working-progress',{ query: query.length ? query : undefined, group_by: values.group_by })
            this.visibleRes = true
            this.result     = Object.values(data)
          }catch (e) {
            this.visibleRes = false
            this.$message.error('Error generating report')
            throw new Error(e)
          }finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
    groupByFilters(group) {
      if (group === 1) return 'contact'
      if (group === 2) return 'responsible'
      if (group === 3) return 'owner'
    },
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
